import React from 'react';
import classes from './topBanner.module.css';

export default function TopBanner(props) {
    return(
        <div className="container">
            <div className={classes.topBanner}>
                {props.title && <h1>{ props.title }</h1>}
                {props.text && <p>{ props.text }</p>}
            </div>
        </div>
    )
}